<template>
  <div class="micro-sidebar">
    <el-menu class="sidebar-el-menu" :default-active="currentRoute">
      <div v-for="(item, i) in menuList" :key="i">
        <SideBarItem :item="item" />
      </div>
    </el-menu>
  </div>
</template>

<script>
import SideBarItem from "./SideBarItem.vue"
import menu from "@/router/menu.js"
export default {
  components: { SideBarItem },
  data() {
    return {
      menuList: []
    }
  },
  computed: {
    currentRoute() {
      return this.$route.query.menu
    }
  },
  created() {
    this.menuList = menu
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.micro-sidebar {
  // position: absolute;
  // left: 0;
  // top: 64px;
  // bottom: 0;
  width: 272px;
  height: calc(100vh - 64px);
  /* background: #324157; */
  width: 500px;
  // 折叠
  .collapse-btn {
    position: absolute;
    left: 24px;
    bottom: 40px;
    padding: 10px;
    cursor: pointer;
    z-index: 10;
    width: 18px;
    img {
      width: 18px;
    }
  }
}
.el-menu {
  background: url(~_img/layout/slide-bg.png);
  background-size: 100% 100%;
  // background: #000;
  font-size: 16px;
  padding: 30px 0;
}
.micro-sidebar::-webkit-scrollbar {
  width: 0 !important;
}
.sidebar-el-menu:not(.el-menu--collapse) {
  width: 250px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.micro-sidebar > ul {
  min-height: 100%;
}
</style>
